import React from 'react';
import {
  TableRow,
  TableCell,
  Box,
  Chip,
  Tooltip,
  Checkbox,
} from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import { DebouncedInput } from '../DebouncedInput';
import { blurOnWheel, PERCENT_INPUT_PROPS } from './gradingInputProps';

function cellVal(v) {
  return v === null || v === undefined ? '' : v;
}

export const GradingRow = React.memo(({ row, idx, sectionKey, onFieldChange }) => {
  const isComplex = sectionKey === 'basicFeatures' || sectionKey === 'bonus';
  const isDeployment = sectionKey === 'deployment';
  const hintText = row.description;
  const showInfoIcon = isDeployment || !!hintText;
  const tooltipBody = isDeployment
    ? hintText || 'No description found in rubric for this item.'
    : hintText;

  return (
    <TableRow>
      <TableCell>
        <Box display="flex" alignItems="center">
          {row.category && (
            <Chip size="small" label={row.category} sx={{ mr: 1, height: 20, fontSize: '0.7rem' }} />
          )}
          {row.name}
          {showInfoIcon && (
            <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipBody}</span>} arrow placement="top">
              <InfoIcon
                sx={{
                  ml: 1,
                  color: hintText ? 'text.disabled' : 'warning.main',
                  cursor: 'help',
                  fontSize: 16,
                }}
              />
            </Tooltip>
          )}
        </Box>
      </TableCell>
      <TableCell>{row.worth}</TableCell>
      {isComplex ? (
        <>
          <TableCell>
            <DebouncedInput
              type="number"
              onWheel={blurOnWheel}
              size="small"
              placeholder="-"
              value={cellVal(row.functionality)}
              onCommit={(v) => onFieldChange(idx, 'functionality', v)}
              InputProps={PERCENT_INPUT_PROPS}
              error={
                cellVal(row.functionality) !== '' &&
                (row.functionality < 0 || row.functionality > 100)
              }
            />
            %
          </TableCell>
          <TableCell>
            <DebouncedInput
              type="number"
              onWheel={blurOnWheel}
              size="small"
              placeholder="-"
              value={cellVal(row.aesthetics)}
              onCommit={(v) => onFieldChange(idx, 'aesthetics', v)}
              InputProps={PERCENT_INPUT_PROPS}
              error={
                cellVal(row.aesthetics) !== '' && (row.aesthetics < 0 || row.aesthetics > 100)
              }
            />
            %
          </TableCell>
          <TableCell sx={{ textAlign: 'center' }}>
            <Tooltip
              title={
                row.aestheticsBonus
                  ? 'Aesthetics weighted at 30% (bonus active)'
                  : 'Enable to weight aesthetics at 30% instead of 20%'
              }
              arrow
            >
              <Checkbox
                size="small"
                checked={!!row.aestheticsBonus}
                onChange={(e) => onFieldChange(idx, 'aestheticsBonus', e.target.checked)}
                sx={{ p: 0.5 }}
              />
            </Tooltip>
          </TableCell>
        </>
      ) : (
        <TableCell colSpan={3}>
          <DebouncedInput
            type="number"
            onWheel={blurOnWheel}
            size="small"
            placeholder="-"
            value={cellVal(row.score)}
            onCommit={(v) => onFieldChange(idx, 'score', v)}
            error={
              parseFloat(row.score) > parseFloat(row.worth) || parseFloat(row.score) < 0
            }
          />
        </TableCell>
      )}
      <TableCell>
        <DebouncedInput
          fullWidth
          size="small"
          variant="standard"
          placeholder="Notes..."
          value={cellVal(row.comment)}
          onCommit={(v) => onFieldChange(idx, 'comment', v)}
        />
      </TableCell>
    </TableRow>
  );
});
